import Tag from '@hilbi/web-common/components/tag';
import { ArrowRightOutlined } from '@icon';
import classNames from 'classnames';
import moment from 'moment';
import { readableColor } from 'polished';
import React, { useMemo } from 'react';
import { useHistory } from 'react-router-dom';
import { CalendarEventItem } from 'types/e-visits';
import { ReactComponent as Icon } from '../../../assets/svg/icon-evisit.svg';
import Avatar from '../../avatar';
import { EVisitsFeedItemSC } from './e-visits-feed-item.styled';

interface EVisitsFeedItemProps {
  event: CalendarEventItem;
}

const EVisitsFeedItem: React.FunctionComponent<EVisitsFeedItemProps> = ({ event }) => {
  const { push } = useHistory();
  const from = moment(event.from);
  const to = moment(event.to);

  const Patient = useMemo(() => {
    if (event.extraData?.client) {
      return (
        <div className="patient">
          <Avatar size={20} imgUrl={event.extraData.client.profileImage} />
          <span className="name">{`${event.extraData.client.firstName} ${event.extraData.client.lastName}`}</span>
        </div>
      );
    }
    return null;
  }, [event]);

  return (
    <EVisitsFeedItemSC onClick={() => push(`/e-visits/calendar/${event.workspace?.id}`)}>
      <div className={classNames('type', { premium: event.tag && event.tag.price !== '0.00' })}>
        <Icon width={16} height={16} />
      </div>
      <div className="left">
        <div className="time">
          <div>
            {from.format('HH:mm')} - {to.format('HH:mm')}
          </div>
          <div className="duration">({to.diff(from, 'minutes')} min.)</div>
        </div>
        {Patient}
      </div>
      <div className="location">
        <div className="name">{event.workspace?.name}</div>
        <div style={{ display: 'flex', gap: 8, marginTop: 8 }}>
          {event.tag ? (
            <Tag
              name={event.tag.abbreviation}
              backgroundColor={event.tag.color}
              textColor={readableColor(event.tag.color)}
            />
          ) : null}
          <div className="badge">{event.workspace?.expertise?.name}</div>
        </div>
      </div>
      <ArrowRightOutlined style={{ margin: 12 }} />
    </EVisitsFeedItemSC>
  );
};

export default React.memo(EVisitsFeedItem);
